import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        loading: false,
        history_loading: false,
        submission_number:null,
        passport_number:null,
        dob:null,
        country:null,
        histories: [],
        next_page_url: '',
        filters: {
            type: null,
            year: null
        },
        showComp:false,
        showFilter:true,
        showOfficerName:true


    }
}

const getters = {
    loading: state => state.loading,
    history_loading: state => state.history_loading,
    filters: state => state.filters,
    visa_number:state =>state.visa_number,
    passport_number:state =>state.passport_number
};

const actions = {
    async getHistory({commit, state}) {
        commit('setHistoryLoading', true);
        try {
            let data = null;
            let trackParams = {
                'dob':state.dob,
                'country':state.country
            }
            trackParams = {...trackParams,...state.filters}
            if (state.submission_number != null && state.passport_number != null) {
                const response = await Http.get(API_URL + VERSION + '/visa-application-tracks/' + state.submission_number + '/' + state.passport_number, {
                    params: trackParams,
                });
                data = response.data;
            } else {
                const response = await Http.get(state.next_page_url, {
                    params: trackParams,
                });
                data = response.data;
            }
            commit('setHistories', data)
            commit('setComp',true)

            commit('setHistoryLoading', false);
        } catch (e) {
            console.log(e);
            commit('setHistoryLoading', false);
            throw e;
        }
    },
    resetState({
                   commit
               }) {
        commit('resetState')
    },
    proceedOnlinePayment({state}, payload) {
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/proceed-online-payment/' + payload.submission_number).then((res) => {
                resolve(res.data);
            }).catch((err) => {
                reject(err)
            });
        })
    },
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    setHistoryLoading(state, loading) {
        state.history_loading = loading;
    },
    setHistories(state, histories) {
        if (histories && !histories.data){
            state.histories = histories;
            state.next_page_url = null;
            state.showFilter = false
            state.showOfficerName = false
        }
        else {
            state.showFilter = false
            state.showOfficerName = false
            if (histories.meta.current_page === 1) {
                state.histories = [...histories.data];
            } else {
                state.histories = [...state.histories, ...histories.data];
            }
            state.next_page_url = histories.links.next;
        }
    },
    setSubmissionNumber(state,submission_number){
        state.submission_number = submission_number
    },
    setPassportNumber(state,passport_number){
        state.passport_number = passport_number
    },
    setComp(state,value){
        state.showComp = value
    }

};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
